import { render, staticRenderFns } from "./basic-salary-history.vue?vue&type=template&id=7d25337c&scoped=true&"
import script from "./basic-salary-history.vue?vue&type=script&lang=js&"
export * from "./basic-salary-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d25337c",
  null
  
)

export default component.exports